import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full h-full items-center" }
const _hoisted_2 = {
  key: 0,
  class: "self-center ml-1.5"
}
const _hoisted_3 = { class: "flex flex-col gap-[3px]" }
const _hoisted_4 = {
  key: 1,
  class: "uil mt-0.5 uil-exclamation-circle text-Text/text_lowest text-[22px]"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "relative w-[1px] flex flex-col items-center ml-auto h-[40px] bg-System/app_grey_76" }, null, -1)

import { computed, ref } from 'vue';
import { IncrediTooltip, IncrediTableSortArrow } from 'incredi-ui';
import { Agent_SortField, Agent_SortOrder } from '@/graphql/codegen/generated/graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'agents-alerts-header',
  props: {
    modelValue: null
  },
  emits: ["update:sort"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line no-unused-vars
  (e: 'update:sort', modelValue: typeof props.modelValue): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: any;
}





const columnName = Agent_SortField.Alerts;
const showAlertsTooltip = ref(false);
const sortArrowsHovered = ref(false);
const sortByCurrentName = computed(() => props.modelValue?.field === columnName);

const setColumnSort = () => {
  // default to ascending
  let order = Agent_SortOrder.Ascending;
  if (props.modelValue?.field === columnName) {
    order = props.modelValue?.order === Agent_SortOrder.Ascending ? Agent_SortOrder.Descending : Agent_SortOrder.Ascending;
  }
  emit('update:sort', {
    field: columnName,
    order,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IncrediTooltip), {
    modelValue: showAlertsTooltip.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showAlertsTooltip).value = $event)),
    hover: "",
    direction: "top-middle",
    "offset-x": 0,
    "offset-y": 5,
    delay: 1000
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", null, _toDisplayString(_unref(columnName)), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        "data-testid": "agents-alerts-sort-icons",
        class: "flex items-center relative h-full w-[36px]",
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (sortArrowsHovered.value = true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (sortArrowsHovered.value = false)),
        onFocusin: _cache[2] || (_cache[2] = ($event: any) => (sortArrowsHovered.value = true)),
        onFocusout: _cache[3] || (_cache[3] = ($event: any) => (sortArrowsHovered.value = false)),
        onClick: setColumnSort
      }, [
        _createElementVNode("div", _hoisted_1, [
          (sortArrowsHovered.value || _unref(sortByCurrentName))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(IncrediTableSortArrow), {
                    direction: "up",
                    value: _unref(sortByCurrentName) && props.modelValue?.order === _unref(Agent_SortOrder).Ascending
                  }, null, 8, ["value"]),
                  _createVNode(_unref(IncrediTableSortArrow), {
                    direction: "down",
                    value: _unref(sortByCurrentName) && props.modelValue?.order === _unref(Agent_SortOrder).Descending
                  }, null, 8, ["value"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("i", _hoisted_4)),
          _hoisted_5
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})